import { render, staticRenderFns } from "./QuestionAttachments.vue?vue&type=template&id=6e570651&scoped=true&"
import script from "./QuestionAttachments.vue?vue&type=script&lang=js&"
export * from "./QuestionAttachments.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAttachments.vue?vue&type=style&index=0&id=6e570651&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e570651",
  null
  
)

export default component.exports